import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=7177119e&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7177119e')) {
      api.createRecord('7177119e', component.options)
    } else {
      api.reload('7177119e', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=7177119e&", function () {
      api.rerender('7177119e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Products.vue"
export default component.exports